import get from 'lodash/get'
import { v1 as uuidv1 } from 'uuid'

import { parseHtml } from '../shared/parseHtml'
import { CONSENT_CHANGED_EVENT, getConsent } from './_cookie-consent'
import { dispatcher } from './dispatcher'
import { CookieConsent } from './module/cookie_consent/model/CookieConsent'

const CODE_TYPE_ANALYTICS = 'analytics'
const CODE_TYPE_MARKETING = 'marketing'
const CODE_LOCATION_HEAD = 'head'
const CODE_LOCATION_CLOSING_BODY = 'closing_body'

const injectedCodes = new Set()
let listenerAdded = false

/**
 * @param {Object|null} code
 */
function normalizeCode(code) {
  if (!code || typeof code !== 'object') {
    return null
  }

  const id = code.id || uuidv1()
  const type = code.type === CODE_TYPE_ANALYTICS ? CODE_TYPE_ANALYTICS : CODE_TYPE_MARKETING
  const location = code.location === CODE_LOCATION_HEAD ? CODE_LOCATION_HEAD : CODE_LOCATION_CLOSING_BODY
  const html = typeof code.html === 'string' ? code.html : ''

  return {
    id,
    type,
    location,
    html,
  }
}

/**
 * @return {Array<{
 *   id: String,
 *   type: String,
 *   location: String,
 *   html: String,
 * }>}
 */
function getCodes() {
  const rawCodes = get(window, ['APP', 'analytics', 'codes'], [])
  if (!Array.isArray(rawCodes)) {
    return []
  }

  return rawCodes.map(normalizeCode).filter((code) => code && code.html.trim() !== '')
}

function injectCodeHtml(code) {
  const target = code.location === CODE_LOCATION_HEAD ? document.head : document.body

  parseHtml(code.html, { executableScripts: true }).forEach((node) => {
    target.appendChild(node)
  })
}

/**
 * @param {CookieConsent|null} consent
 */
function renderCodes(consent) {
  getCodes().forEach((code) => {
    if (injectedCodes.has(code.id)) {
      return
    }

    if (code.type === CODE_TYPE_ANALYTICS && (!consent || !consent.analytics)) {
      return
    }

    if (code.type === CODE_TYPE_MARKETING && (!consent || !consent.marketing)) {
      return
    }

    injectCodeHtml(code)
    injectedCodes.add(code.id)
  })
}

function setupAnalyticsCodes() {
  renderCodes(getConsent())

  if (listenerAdded) {
    return
  }

  dispatcher.addListener(CONSENT_CHANGED_EVENT, (ev) => {
    renderCodes(ev.consent)
  })
  listenerAdded = true
}

export { setupAnalyticsCodes }
